import { HStack, Box, IconButton, Text } from '@cad-arc';
import { UnitHistoryEventView } from '@mark43/cad-api';
import { intersperse } from '../../../common/helpers/intersperse';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { UnitHistoryForm } from '../../types';
import { FR_UNIT_HISTORY_PATH } from '../../../router/constants';
import { useOpenEvent } from '../../../common/hooks/use-open-event';

export function EventsTitle({ events }: { events: UnitHistoryEventView[] }): React.ReactElement {
    const { form } = useIntegratedForm<UnitHistoryForm>();

    const currentFormSearchData = form.getValues();

    const locationState = {
        previousLocationPathname: FR_UNIT_HISTORY_PATH,
        unitHistorySearchData: { ...currentFormSearchData },
    };

    const openEvent = useOpenEvent();

    return (
        <HStack>
            {intersperse(
                events.map((event) => (
                    <HStack key={event.id} spacing="4px">
                        <Text variant="headingSm">Event {event.agencyEventNumber}</Text>
                        <IconButton
                            variant="ghost"
                            icon="OpenNewWindow"
                            onClick={() =>
                                openEvent({
                                    eventId: event.id,
                                    frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                                    locationState,
                                })
                            }
                            aria-label="Open event"
                            size="sm"
                        />
                    </HStack>
                )),
                <>/</>
            ).map((element, idx) => (
                <Box as="span" key={idx}>
                    {element}
                </Box>
            ))}
        </HStack>
    );
}
